import { useMemo } from "react";

export default function RatingPanel({ rating }: { rating: number }) {
  const stars = Math.round((rating / 10) * 5);

  const distribution = useMemo(() => {
    const base = rating / 10;
    return [
      { label: "5 星", value: Math.round(base * 72) },
      { label: "4 星", value: Math.round(base * 20) },
      { label: "3 星", value: Math.round((1 - base) * 24) },
      { label: "2 星", value: Math.round((1 - base) * 9) },
      { label: "1 星", value: Math.round((1 - base) * 4) },
    ];
  }, [rating]);

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-6">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <i className="ri-award-line text-accent-600"></i>
        推荐指数
      </h2>

      <div className="mt-5 flex items-end gap-4">
        <span className="font-heading text-5xl font-bold leading-none text-primary-700">
          {rating.toFixed(1)}
        </span>
        <div className="pb-1">
          <div className="flex items-center gap-0.5 text-accent-500">
            {Array.from({ length: 5 }, (_, index) => (
              <i
                key={index}
                className={index < stars ? "ri-star-fill text-lg" : "ri-star-line text-lg text-foreground-300"}
              ></i>
            ))}
          </div>
          <p className="mt-1 text-xs text-foreground-500">满分 10 分 · 演示数据</p>
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-2.5">
        {distribution.map((row) => (
          <div key={row.label} className="flex items-center gap-3">
            <span className="w-10 shrink-0 text-xs text-foreground-500">{row.label}</span>
            <span className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
              <span
                className="block h-full rounded-full bg-secondary-500"
                style={{ width: `${Math.min(100, Math.max(4, row.value))}%` }}
              ></span>
            </span>
            <span className="w-8 shrink-0 text-right text-xs text-foreground-400">{row.value}%</span>
          </div>
        ))}
      </div>

      <p className="mt-5 rounded-md bg-background-100 p-3 text-xs leading-relaxed text-foreground-500">
        本站暂未开放用户打分系统，以上评分为编辑整理的推荐参考，仅作演示展示。
      </p>
    </div>
  );
}